"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var MaintaenanceBanner_1 = require("components/MaintaenanceBanner");
var components_1 = require("../components");
require("./App.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('App'), recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(MaintaenanceBanner_1.default, null),
        React.createElement("div", { className: classNames('app-container', __SOKOBID_PORTAL__ && 'sokobid-portal') },
            React.createElement(components_1.TopNavigationBar, null),
            React.createElement("div", { className: "content-wrapper" },
                React.createElement(components_1.LeftNavigation, null),
                props.children,
                !__SOKOBID_PORTAL__ && React.createElement(components_1.FileUploadStatusBar, null)))));
});
